import clsx from "clsx"

import { useStepStack } from "@molecules/StepStack/StepStack.context"

import ComponentNavigation from "@organisms/ComponentNavigation/ComponentNavigation"

import styles from "./StepStackContent.module.scss"
import { StepStackContentProps } from "./StepStackContent.types"

export default function StepStackContent({ children, className }: StepStackContentProps) {
    const { currentItemId, navigateTo, transitionDurationMS, orderedIds } = useStepStack()

    return (
        <ComponentNavigation.Provider
            keepMounted={true}
            currentComponentId={currentItemId ?? undefined}
            onNavigate={navigateTo}
            transitionDurationMS={transitionDurationMS}
            componentIds={orderedIds}
        >
            <ComponentNavigation.Root className={clsx(styles.base, className)}>{children}</ComponentNavigation.Root>
        </ComponentNavigation.Provider>
    )
}
